import React, { useEffect, useState } from "react";
import { brainGame } from "../../system/types/brainGame/brainGame";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import { language } from "../../system/types/project/language";
import { useTranslations } from "../../hooks/useTranslations";
import { dispatch } from "../../App";
import { actions } from "../../redux";

const LanguageSelect = () => {

    const { t } = useTranslations();

    const [brainGameData, setBrainGameData] = useState<brainGame | undefined>();
    const [baseLanguage, setBaseLanguage] = useState<language>();
    const [selectedLanguage, setSelectedLanguage] = useState<language>();
    const [languageList, setLanguageList] = useState<language[]>([]);

    useSelector((state: RootState) => {
        if (state.brainGame.gameData !== brainGameData) {
            setBrainGameData(state.brainGame.gameData);
        }
        if (state.brainGame.activeLanguage !== selectedLanguage) {
            setSelectedLanguage(state.brainGame.activeLanguage);
        }
    });

    const showAvailabelLanguages = () => {
        if (typeof brainGameData === 'undefined') {
            return;
        }

        setBaseLanguage(brainGameData.baseLanguage);
        setLanguageList(brainGameData.languages);
    };

    const changeLanguageSelect = (event: any) => {
        const newValue = event.target.value;

        languageList.forEach((entry) => {
            if (entry.isoCode === newValue) {
                dispatch(actions.brainGame.setActiveLanguage(entry));
            }
        });
    };

    useEffect(() => {
        showAvailabelLanguages();
    }, [brainGameData]);


    return (
        <>{
            typeof brainGameData === 'undefined' ? null : (
                <div className="row mb-3 mt-3 align-items-center">
                    <div className="col-auto">{baseLanguage?.name}</div>
                    <div className="col-auto"> -&gt; </div>
                    <div className="col-auto">
                        <div className="input-group formElement">
                            <label className="input-group-text" id="selectLanguageLabel">{t('braingame.selecttraininglanguage')}</label>
                            <select
                                id="selectLanguage"
                                name="selectLanguage"
                                className="form-control"
                                aria-label={t('braingame.selectLanguage')}
                                aria-describedby="selectLanguageLabel"
                                onChange={changeLanguageSelect}
                                value={selectedLanguage?.isoCode}
                            >
                                {typeof selectedLanguage === 'undefined' || selectedLanguage.isoCode === '' ?
                                    <option key="" value="">{t('projects.selectalanguage')}</option>
                                    : null}
                                {languageList.map(language => (
                                    <option key={language.isoCode} value={language.isoCode}>
                                        {language.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                    </div>
                </div>

            )
        }
        </>
    );
};

export { LanguageSelect };
